<div class="outrights-container text">
  <div class="breadcrumb-container text" *ngIf="this._DataHelper.isOutRights == true" (click)="goBack()">
    <div class="breadcrumb-left">
      <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
    </div>

    <div class="breadcrumb-mid">
      <div class="breadcrumb-tournament-noname"><strong> Sports </strong></div>
    </div>

    <div class="breadcrumb-right">
      <div class="star-icon"></div>
    </div>
  </div>
  <ng-container *ngFor="let oddsmarket of this.outrightMatchOddsList | groupOutrightsOddsByName">
    <div class="outrights-row" (click)="openOutrightsRow(oddsmarket)">
      <div class="outrights-favorite">
        <image-loader-utils url="star" [extraClasses]="'star-icon '"></image-loader-utils>
      </div>
      <div class="outrights-title">
        {{ oddsmarket.GroupName }}
      </div>
    </div>

    <div class="outrights-row-content" *ngIf="groupName == oddsmarket.GroupName || defaultRowOpened">
      <ng-container *ngFor="let item of oddsmarket.eOdds">
        <div class="outrights-odd-button" (click)="clickOdd(item.OddId)" [ngClass]="checkOddId(item.OddId)">
          <div class="left">
            {{ item.OutCome }}
          </div>
          <div class="right">
            {{ item.OddValue | number : '1.2-2' }}
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
